/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'django-sdk',
  title: 'Django SDK',
  category: 'SDKs & API',
  summary:
    'Report unhandled exceptions and log records from a Django app to PulseWatch, and optionally trace requests. Pure standard library, no dependencies.',
  keywords: ['Django', 'Python', 'SDK', 'middleware', 'logging', 'capture_exception', 'PULSEWATCH settings'],
};

export const loadComponent = () => import('./django-sdk.component').then((m) => m.DjangoSdkArticleComponent);
